var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEcScores(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h12v12H8z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 15.38c0-.935.848-1.694 1.895-1.694h1.263v5.647H9.895C8.848 19.333 8 18.575 8 17.64V15.38z",
    fill: "#FEAAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.965 14.06c.181-.7-.366-1.379-1.11-1.379l-3.402-.001.314-1.826c.153-.884-.332-1.755-1.177-2.119-.537-.23-1.141.15-1.141.718v.98c0 .378-.133.744-.377 1.04l-1.914 2.316v5.544h6.104c.788 0 1.475-.52 1.666-1.26l1.037-4.014z",
    fill: "#655AEC"
  })))));
}

export default SvgEcScores;